import { render, staticRenderFns } from "./ITableTh.vue?vue&type=template&id=445f8a01"
import script from "./ITableTh.vue?vue&type=script&lang=js"
export * from "./ITableTh.vue?vue&type=script&lang=js"
import style0 from "./ITableTh.vue?vue&type=style&index=0&id=445f8a01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports